import { useParams } from 'react-router-dom';
import useFetch from '../../api/useFetch';
import EmployeeInfo from './EmployeeInfo';
import { Box } from '@mui/material';
import Header from '../../components/special/Header';
import ExoAvatar from '../../components/exo/ExoAvatar';
import Logout from '../../auth/Logout';
import { tokens } from '../../global/theme/tokens';
import { useTheme } from '@emotion/react';

export const ShowEmployee = ({ api, own }) => {
  const { id } = useParams();
  const { apiData, isLoading, setApiData } = useFetch(api || `users/${id}`);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const name = apiData
    ? `${apiData.data.firstName} ${apiData.data.lastName}`
    : ' ';

  function handleChange(updatedUser) {
    setApiData({ ...apiData, data: updatedUser });
  }

  return (
    <Box className="flex flex-col h-full">
      <Box className="flex flex-row justify-between items-center">
        <Header
          title={
            <>
              <ExoAvatar
                picture={
                  apiData &&
                  apiData.data.picture &&
                  apiData.data.picture.temporaryUrl
                }
                size="50px"
              />
              {name}
            </>
          }
        />
        <Box className="lg:hidden md:hidden">
          <Logout
            sx={{
              backgroundColor: colors.glass,
              borderRadius: '8px',
              padding: '8px',
              marginRight: '4px',
            }}
            isOpen={true}
          />
        </Box>
      </Box>
      <EmployeeInfo
        employeeInfo={apiData && apiData.data}
        isLoading={!apiData}
        onChange={handleChange}
        noHead
        own={own}
      />
    </Box>
  );
};
